import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientRef } from '../models/client-ref.model';

// Isolated from IClientsRepository on purpose -- appointments only needs a narrow read-only
// lookup (search by name -> id + patients), not the full clients CRUD surface, and features
// must not import each other's domain/data layers directly.
export interface IAppointmentClientLookupRepository {
  search(term: string): Observable<readonly ClientRef[]>;
  // Resolves a single client (name + patients) from a bare id -- used by the new-appointment
  // drawer's edit-mode prefill, which only has Appointment.clientId to work with. Returns null
  // when the client can't be found (e.g. deleted) so callers can degrade gracefully.
  getById(id: string): Observable<ClientRef | null>;
  // Batched variant of getById -- resolves multiple client ids in a single request. The returned
  // map always has one entry per requested id (missing/not-found ids map to null), so callers can
  // rely on every requested id being present.
  getByIds(ids: readonly string[]): Observable<ReadonlyMap<string, ClientRef | null>>;
}

export const APPOINTMENT_CLIENT_LOOKUP_REPOSITORY = new InjectionToken<IAppointmentClientLookupRepository>(
  'IAppointmentClientLookupRepository',
);
